import { render } from "./Pa-Contact.vue?vue&type=template&id=707ce130"
import script from "./Pa-Contact.vue?vue&type=script&lang=js"
export * from "./Pa-Contact.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/prime-asia-lg-samsung/prime-asia-lg-samsung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__